import { APPLY_DISCOUNT, GET_ALL_DISCOUNT, GET_TRANSACTION, GET_TRANSACTION_ANALYTICS, GET_TRANSACTION_FAILED, GET_TRANSACTION_REQUEST, PLACE_ORDER, PLACE_ORDER_FAILED, PLACE_ORDER_REQUEST, RETURN_PRODUCT, RETURN_PRODUCT_FAILED, RETURN_PRODUCT_REQUEST, SEND_INVOICE, SEND_INVOICE_FAILED, SEND_INVOICE_REQUEST } from '../action.type';
const intialState = {
  ordeInfo: null,
  allDiscount: null,
  transactions: null,
  transactionAnalytics: null,
  discountInfo: null,
  orderLoader: true,
  transactionsLoader: true,
  sendInvoiceLoader: false,
  returnProduct: null,
  returnProductLoader: false
};

export const orderReducer = (state = intialState, action) => {
  switch (action.type) {
    case PLACE_ORDER_REQUEST:
      return {
        ...state,
        orderLoader: true,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case PLACE_ORDER:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        ordeInfo: action.payload,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case PLACE_ORDER_FAILED:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case GET_ALL_DISCOUNT:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        allDiscount: action.payload,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case GET_TRANSACTION_REQUEST:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: true,
        transactions: null,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case GET_TRANSACTION:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        transactions: action.payload,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case GET_TRANSACTION_FAILED:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        transactions: null,
        returnProductLoader: false
      };
    case GET_TRANSACTION_ANALYTICS:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        transactionAnalytics: action.payload,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case APPLY_DISCOUNT:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        discountInfo: action.payload,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case SEND_INVOICE_REQUEST:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: true,
        returnProductLoader: false
      };
    case SEND_INVOICE:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case SEND_INVOICE_FAILED:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case RETURN_PRODUCT_REQUEST:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: true
      };
    case RETURN_PRODUCT:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
    case RETURN_PRODUCT_FAILED:
      return {
        ...state,
        orderLoader: false,
        transactionsLoader: false,
        sendInvoiceLoader: false,
        returnProductLoader: false
      };
      
    default:
      return state;
  }
};
